<script>
import axios from "axios";
import * as Sentry from "@sentry/browser";

const MAX_TRIES = 2;

export default {
  methods: {
    handlePhSearchChange(searchQuery) {
      if (!searchQuery) {
        return;
      }

      // Clear the previous timer
      clearTimeout(this.typingTimeout);

      // Set a new timer to call the API after debounceDelay milliseconds
      this.typingTimeout = setTimeout(async () => {
        this.isSearchingHp = true;

        const data = await this.retrievePhenotypeList(searchQuery);

        this.isSearchingHp = false;

        if (data) {
          if (data.totalCount === 0) {
            this.foundPhData = false;
            this.phSearchMsg = "No results found";
          } else {
            this.foundPhData = true;
            const phData = data.terms.map(
              (term) => `${term.id} - ${term.name}`
            );

            // Add selected phenotypes in phenotypeList to make use of built-in <auto-complete> UI feature
            this.phenotypeList = [...phData, ...this.phenotypes];
          }
        }
      }, this.debounceDelay);
    },
    async retrievePhenotypeList(searchQuery) {
      let res = null;

      // Try API call twice before displaying Alert on the screen
      for (let i = 1; i <= MAX_TRIES; i++) {
        res = await this.callHpApi(searchQuery);

        // If the API call has got response, exit the loop
        if (res.success) break;

        if (!res.success) {
          if (res.response === 'ERR_NETWORK' || res.response === 'UNKNOWN')
            this.brokenPhenotypesApi = true;
          if (res.response === 'ERR_BAD_RESPONSE')
            this.badSearchQuery = true;

          this.$set(this, "phenotypeList", []);
          this.$set(this, "foundPhData", false);
          this.$set(this, "phenotypes", []);
        }

      }

      if (!res) {
        Sentry.captureException(
          `Caught error when calling retrievePhenotypeList`
        );
        return res;
      }

      return res.response.data;
    },
    async callHpApi(searchQuery) {
      const hpSearchEndpoint = `https://ontology.jax.org/api/hp/search?q=${searchQuery}&page=0&limit=30`;

      try {
        const response = await axios.get(hpSearchEndpoint);
        return {success: true, response: response}
      } catch (error) {
        console.log(
          `Caught error when making API call to ${hpSearchEndpoint}:`,
          error
        )
        if (error.code === 'ERR_NETWORK') 
          return {success: false, response: 'ERR_NETWORK'}
        if (error.code === 'ERR_BAD_RESPONSE' || error.code === 'ERR_BAD_REQUEST')
          return {success: false, response: 'ERR_BAD_RESPONSE'}
        else 
          return {success: false, response: 'UNKNOWN'}
      }
    },
    filterPhItems(item, queryText, itemText) {
      // Overwrite default `filter` props for v-autocomplete to display results that does not contain search query input string
      // For more: https:github.com/vuetifyjs/vuetify/blob/v2-stable/packages/vuetify/src/components/VAutocomplete/VAutocomplete.ts#L40

      return queryText && this.foundPhData;
    },
    // Convert phenotypes value to "<id> - <name>|<id> - <name>|..."
    getFinalPhenotypes(phenotypesArr) {
      return phenotypesArr.join("|");
    },
    // Used to display phenotypes value in Summary screen for prenatal test(s)
    displayPrenatalPhenoList(pipedVal) {
      return pipedVal.replace(/\|/g, ", ");
    },
  },
  data() {
    return {
      phenotypeList: null,
      debounceDelay: 300,
      typingTimeout: null,
      isSearchingHp: null,
      phSearchMsg: "Start typing for finding results",
      foundPhData: false,
      brokenPhenotypesApi: false,
      badSearchQuery: false,
    };
  },
};
</script>
